var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selected)?_c('div',{staticClass:"mt-n6"},[_c(_vm.componentFile,{tag:"component",attrs:{"account_credentials":{},"carrier_account_name":null}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }